module.exports = __webpack_public_path__ + "img/363.dce9d6bf.jpg";